import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import moment from 'moment/min/moment-with-locales';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule}  from '@angular/material/toolbar'
import { PermissionsService } from './auth/auth-guard.guard';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {OverlayContainer} from '@angular/cdk/overlay';
import { HomeComponent } from './home/home.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { CheckUpdateService } from './shared/services/check-update.service';
import { Globals } from './shared/models/globals';
import { AppColorsService } from './shared/services/app-colors.service';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterModule, MatIconModule, MatToolbarModule, TranslateModule, CommonModule, MatButtonModule, NavigationComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'Scout';
  private readonly loginTheme = 'dark';

  

  ngOnInit() {
    
  }
  


  constructor(public translate: TranslateService,
              public _globals: Globals,    
              private router: Router,
              private overlayContainer: OverlayContainer,
              private appColorsService: AppColorsService,
              private update: CheckUpdateService) {


    //LANGUAGE
    translate.addLangs(['en-US', 'sv-SE']);
    translate.setDefaultLang('en-US');  //fallback language    
    var language = localStorage.getItem("language")??'en-US';
    //console.log("DS Scout----app-component: var language=" +  language);
    translate.use(language); 
    moment.locale(language?.substring(0,2));

    //Theming
    this.overlayContainer.getContainerElement().classList.remove("darkMode");
    this.overlayContainer.getContainerElement().classList.remove("lightMode");
    _globals.theme = localStorage.getItem("theme")??"dark";
    this.overlayContainer.getContainerElement().classList.add(_globals.theme + "Mode");
    document.body.classList.remove('dark-mode');
    document.body.classList.remove('light-mode');
    document.body.classList.add(_globals.theme + '-mode');
    this.appColorsService.applyStoredThemeColors(_globals.theme);
  
    // Apply theme for current route on initial load
    this.applyThemeForRoute(this.router.url);

    // Listen to navigation events to apply theme for login routes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.applyThemeForRoute(event.urlAfterRedirects);
    });
   
 
    //const browserLang = translate.getBrowserCultureLang()?? "";    
    //console.log("DS Scout----app-component: BrowserLang=" +  browserLang);
    //console.log("DS Scout----app-component: BrowserLang match ");
    //console.log(browserLang.match(/en-US|sv-SE/) ? browserLang : 'en-US' );
    //translate.use(browserLang.match(/en-US|sv-SE/) ? browserLang : 'en-US'); //Use browsers lang


    //var prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
   
  }

  private applyThemeForRoute(url: string): void {
    const isLoginScreen = this.isLoginRoute(url);
    const themeToApply = isLoginScreen
      ? this.loginTheme
      : (localStorage.getItem('theme') ?? 'dark');

    this.applyTheme(themeToApply);
  }

  private isLoginRoute(url: string): boolean {
    return url === '/login' || url === '/login/login';
  }

  private applyTheme(theme: string): void {
    this.overlayContainer.getContainerElement().classList.remove('darkMode');
    this.overlayContainer.getContainerElement().classList.remove('lightMode');
    this._globals.theme = theme;
    this.overlayContainer.getContainerElement().classList.add(theme + 'Mode');
    document.body.classList.remove('dark-mode');
    document.body.classList.remove('light-mode');
    document.body.classList.add(theme + '-mode');
    this.appColorsService.applyStoredThemeColors(theme);
  }

}
